<template>
    <b-modal
        :hide-footer="true"
        size="lg"
        :title="anexo.nome"
        centered
        id="view-file"
    >
        <div class="row" v-if="loading">
            <load mode="table" />
        </div>
        <div v-else class="row">
            <video
                width="100%"
                height="30%"
                controls
                v-if="anexo.tipo == 'video/mp4' || anexo.tipo == 'mp4'"
            >
                <source :src="path" type="video/mp4" />
                <source :src="path" type="video/ogg" />
                Seu navegador não suporta a tag de vídeo.
            </video>
            <img
                :src="path"
                :alt="anexo.nome"
                class="col-12"
                v-if="
                    anexo.tipo == 'image/jpeg' ||
                    anexo.tipo == 'image/jpg' ||
                    anexo.tipo == 'image/png' ||
                    anexo.tipo == 'image/gif' ||
                    anexo.tipo == 'jpeg' ||
                    anexo.tipo == 'jpg' ||
                    anexo.tipo == 'png' ||
                    anexo.tipo == 'gif' ||
                    anexo.tipo == 'image'
                "
            />
            <iframe
                v-if="
                    anexo.tipo ==
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    anexo.tipo ==
                        'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
                    anexo.tipo == 'application/pdf' ||
                    anexo.tipo == 'pdf' ||
                    anexo.tipo == 'docx' ||
                    anexo.tipo == 'doc' ||
                    anexo.tipo == 'ppt' ||
                    anexo.tipo == 'pptx' ||
                    anexo.tipo == 'txt' ||
                    anexo.tipo == 'xls' ||
                    anexo.tipo == 'xlsx' ||
                    anexo.tipo == 'csv' ||
                    anexo.tipo == 'sql' ||
                    anexo.tipo == 'text/plain'
                "
                class="col"
                :src="`https://docs.google.com/gview?url=${path}&embedded=true`"
                style="width: 100%; height: 400px"
                frameborder="0"
                id="iframe"
                @load="loading = false"
            ></iframe>
            <!-- <button
                class="btn btn-success btn-block btn-sm mx-3"
                v-if="
                    anexo.tipo == 'application/zip' ||
                    anexo.tipo == 'zip' ||
                    anexo.tipo == 'rar'
                "
                @click="download(path, anexo.nome)"
            >
                Baixar {{ anexo.nome }}
            </button> -->
            <div class="col-12">
                <div class="row d-flex justify-content-end">
                    <button
                        class="col-auto btn btn-success btn-sm mx-3 mt-3"
                        @click="downloadFile(anexo)"
                    >
                        Baixar {{ anexo.nome }}
                    </button>
                </div>
            </div>
        </div>
        <modulo-comentario
            module="GerenciadorArquivo"
            model="Anexo"
            :id="anexo.file_id ? anexo.file_id : anexo.id"
        />
    </b-modal>
</template>
<script>
export default {
    props: ["anexo"],
    data() {
        return {
            path: {},
            loading: true,
            urlbase: `${window.location.protocol}//${window.location.host}/`,
        };
    },
    watch: {
        anexo(n, o) {
            this.path =
                this.urlbase + this.anexo.caminho + "/" + this.anexo.nome;

            this.loading = true;
            if (this.verificarTipo(this.anexo.tipo) == "arquivo") {
                setInterval(() => {
                    this.loading = false;
                }, 500);
            } else {
                this.loading = false;
            }
            if (this.verificarTipo(this.anexo.tipo) == "arquivo") {
                this.anexo.tipo = this.formatFile(this.anexo.nome);
            }
        },
    },
    mounted() {},
    methods: {
        downloadFile(anexo) {
            let path = this.urlbase + anexo.caminho + "/" + anexo.nome;
            // window.open(path, "_blank");

            var anchor = document.createElement("a");
            anchor.href = path;
            anchor.download = path;
            document.body.appendChild(anchor);
            anchor.click();
        },
        verificarTipo(tipo) {
            if (
                tipo == "image/jpeg" ||
                tipo == "image/jpg" ||
                tipo == "image/png" ||
                tipo == "image/gif"
            ) {
                return "image";
            } else {
                return "arquivo";
            }
        },
        formatFile(file) {
            var ex = file.split(".");
            return ex.length == 1 ? "folder" : ex.pop();
        },
        download(fileUrl, fileName) {
            let timerInterval;
            swal.fire({
                html: "O arquivo está sendo preparado e logo será baixado.",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                    swal.showLoading();
                    const b = swal.getHtmlContainer().querySelector("b");
                    timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft();
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                },
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === swal.DismissReason.timer) {
                    //console.log("I was closed by the timer");
                }
            });
            var a = document.createElement("a");
            a.href = fileUrl;
            a.setAttribute("download", fileName);
            a.click();
        },
    },
};
</script>
